<template>
    <div class="container">
        <!-- 轮播图组件 -->
        <!-- <carousel :autoplay="true" :autoplay-speed="1000" :loop="true" :pagination-enabled="false" height="300px"
            :per-page="1">
            <slide v-for="(image, index) in images" :key="index">
                <img :src="require('@/assets/images/' + image.filename)" :alt="image.alt"
                    class="img-fluid desktop-image" :style="{ maxHeight: image.maxHeight }">
            </slide>
        </carousel> -->

        <!-- <div class="outer-div">
            <div class="brand-info">
                <h2>品牌文化：CATCH THE MOMENT抓住美好瞬间</h2>
                <span>品牌理念：勇敢的抓住每刻属于真我的瞬间</span>
                <span>品牌使命：将高质量和高性价比产品带给消费者</span>
                <span>品牌价值观：时尚、责任、创新、品质、诚信、感恩</span>
                <span>品牌个性：多彩 自信 年轻 潮流</span>
                <span>AFFLATUS：富有创造性的思维力，开启美好的灵感时刻</span>
                <span>KEEP:保持状态，持续精彩</span>
                <span>FLAG:向前的姿态，成为引领者</span>
                <span>ΛKF用心“专研、有效”的好产品，让客户“安心”使用，以匠心精神，打造至臻至美的产品，给每一位消费者最直观的沉浸式美妆体验，专注品牌、专注品质、专注时尚。</span>
            </div>
        </div> -->
        <div class="row">
            <div class="col-md-6 offset-md-3">
                <div v-for="(image, index) in images" :key="index" class="mb-4 text-center">
                    <!-- <p class="desktop-image-description">{{ image.description }}</p> -->
                    <!-- <img :src="require('@/assets/images/brandCulture/' + image.filename)" :alt="image.alt"
                        class="img-fluid desktop-image" :style="{ maxHeight: image.maxHeight }"
                        @click="goToBuyPage(image.productId)"> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
export default {
    name: 'BrandInfo', // 组件名称
    components: {
        Carousel,
        Slide
    },
    data() {
        return {
            images: [
                {
                    filename: '18.png',
                    alt: 'Image 1',
                    description: '轻盈似雪 自然定格',
                    maxHeight: '800px', // 移动端图片的最大高度
                    productId: '1001' // 产品ID
                },
                {
                    filename: '19.png',
                    alt: 'Image 2',
                    description: '创新雾化科技 打破定妆难题',
                    maxHeight: '800px', // 移动端图片的最大高度
                    productId: '1002' // 产品ID
                },
                {
                    filename: '20.png',
                    alt: 'Image 3',
                    description: '精致眼妆 悦动笔上',
                    maxHeight: '800px', // 移动端图片的最大高度
                    productId: '1003' // 产品ID
                },
                {
                    filename: '21.png',
                    alt: 'Image 4',
                    description: '持久卷翘 细睫出众',
                    maxHeight: '800px', // 移动端图片的最大高度
                    productId: '1004' // 产品ID
                },

            ],
        }
    }
}
</script>

<style scoped>
/* 样式 */
.desktop-image {
    width: 1000px;
    /* 设置图片宽度为屏幕宽度的80% */
}

.container {
    margin-top: 140px;
}

.outer-div {
    /* 如果需要的话，设置外层div的样式 */
    text-align: center;
    /* 水平居中，但这通常对内部块级元素有效 */
}

.brand-info {
    /* 设置内部div的样式 */
    text-align: center;
    /* 水平居中内部的文本和块级元素 */
}

.brand-info span {
    display: block;
    /* 使span表现得像块级元素，每个独占一行 */
    margin-bottom: 10px;
    /* 设置每个span元素之间的垂直间隔 */
}

/* 如果不需要h2也独占一行，并且希望它与下面的span有相同的间隔，可以给h2也添加margin-bottom */
.brand-info h2 {
    margin-bottom: 10px;
}
/* 图片尺寸调大 */
@media (min-width: 768px) {
    .offset-md-3  {
        margin-left: 0;
    }
    .col-md-6{
        width: 100%;
    }
    
}
</style>